<template>
  <v-container class="bg-white">
    <v-card
      class="pa-5"
      variant="text">
      <v-card-title>Eigene Lizenz bearbeiten</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6"> Zahlungsart </v-col>
          <v-col cols="6"> Visa </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
      </v-card-actions>
    </v-card>
    <v-divider></v-divider>
    <ModuleList
      v-if="modules"
      :modules="modules"
      :user-count="1" />
  </v-container>
</template>

<script lang="ts" setup>
import { useSpaceStore } from "@/stores/spaceStore";
import axios from "axios";
import { useTranslation } from "i18next-vue";
import { onMounted } from "vue";
import { computed } from "vue";
import { ref } from "vue";
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { SPACE_RIGHT_WRITE, spaceRightNames } from "@/utils/constants";
import { useMainStore } from "@/stores/mainStore";
import { useAuthStore } from "@/stores/authStore";
import { SPACE_RIGHT_READ, MODULES } from "@/utils/constants";
import ModuleList from "./Licence/ModuleList.vue";

const { t } = useTranslation();
const createConfirm = useConfirm();
const createSnackbar = useSnackbar();

const emits = defineEmits(["close"]);

const modules = ref(0);

onMounted(() => {
  axios.get("/api/licence/private").then((response) => {
    console.log(response.data);

    modules.value = Number(response?.data?.modules) || 1;
  });
});
</script>
